import '../Bootstrap';

import {XH} from '@xh/hoist/core';
import {RzxApp} from '../rzx/RzxApp';
import {RzxAuthModel} from '../core/RzxAuthModel';
import {textInput} from '@xh/hoist/desktop/cmp/input';
import {RzxAppModel} from '../rzx/RzxAppModel';
import {AppContainer} from '@xh/hoist/desktop/appcontainer';

RzxAuthModel.textInput = textInput;

XH.renderApp({
    clientAppCode: 'rzx',
    clientAppName: 'RZX',
    componentClass: RzxApp,
    modelClass: RzxAppModel,
    containerClass: AppContainer,
    authModelClass: RzxAuthModel,
    isMobileApp: false,
    enableLogout: true,
    checkAccess: () => true
});
